export function CoreEventRun ($rootScope, $transitions) {
  $transitions.onStart({}, () => {
    $rootScope.loaded = false;
  });

  $transitions.onSuccess({}, () => {
    $rootScope.loaded = true;

    if ( 'scrollRestoration' in history ) {
      history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);
  });
}